import { generateMenus, generateAccessRouters } from './menu'
const permission = {
  state: {
    loaded: false,
    menus: [],
    modules: [], // modules 暂时没用
    hideLaborMenu: true, // 控制是否隐藏劳务管理菜单的开关，无论是前端菜单的显示/隐藏，还是默认重定向的菜单选择，都会同时受到这个开关的控制
  },
  mutations: {
    SET_ROUTE_LOADED: (state, loaded = true) => {
      state.loaded = loaded
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    RESET_PERMISSION(state) {
      state.loaded = false
      state.menus = []
      state.modules = []
    },
  },
  actions: {
    async GenerateRoutes({ commit, state }, { processedMenus }) {
      // 基于菜单创建真正的路由
      const accessRouters = generateAccessRouters(processedMenus)

      // 过滤掉劳务管理菜单，用于默认重定向
      let targetMenus = processedMenus
      if (state.hideLaborMenu) {
        targetMenus = processedMenus.filter(item => item.meta.title !== '劳务管理' && item.meta.title !== '劳务管理V2')
      }

      const asyncRouterMap = [
        ...accessRouters,
        // 一个菜单都没有，重定向到403
        {
          path: '/',
          redirect: targetMenus[0] ? targetMenus[0].path : '/403',
        },
        {
          path: '*',
          redirect: '/404',
        },
      ]
      return asyncRouterMap
    },
    async GenerateMenus({ commit }, { menus }) {
      const processedMenus = generateMenus(menus)
      commit('SET_MENUS', processedMenus)
      return processedMenus
    },
  },
}

export default permission
